var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
const SORTED_DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
const DAYS_TO_SHORT_MAP = {
  MON: 0,
  TUE: 1,
  WED: 2,
  THU: 3,
  FRI: 4,
  SAT: 5,
  SUN: 6
};
let FormatDayHourPeriods = (_class = class FormatDayHourPeriods extends Helper {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
  }
  /**
   * Formats the provided periods: FormatDayPeriod[] into a single string per each unique day / time combination.
   *
   * Example; we have five periods where MON, TUE, WED and THUR share the same time of 9AM to 5AM and FRI
   * has a different time of 10AM to 5PM.
   * [
   *   {
   *     dayOfWeek: "MON",
   *     startTime: "09:00:00",
   *     endTime: "17:00:00",
   *   },
   *   {
   *     dayOfWeek: "TUE",
   *     startTime: "09:00:00",
   *     endTime: "17:00:00",
   *   },
   *   {
   *     dayOfWeek: "WED",
   *     startTime: "09:00:00",
   *     endTime: "17:00:00",
   *   },
   *   {
   *     dayOfWeek: "THUR",
   *     startTime: "09:00:00",
   *     endTime: "17:00:00",
   *   }
   *   {
   *     dayOfWeek: "FRI",
   *     startTime: "10:00:00",
   *     endTime: "17:00:00",
   *   }
   * ]
   *
   * This will result in the following; Mon–Thu: 9AM – 5PM • Fri: 10AM – 5PM • Sat, Sun: Closed
   * When consecutive days are found as in the case of Mon - Thu the days between are not shown
   */
  compute([periods]) {
    if (!periods || periods.length === 0) {
      return '';
    }
    const groupedPeriods = this.groupPeriodsByStartAndEndTime(periods);
    const formattedPeriods = [];
    for (const [key, days] of Object.entries(groupedPeriods)) {
      const [startTime, endTime] = key.split('-');
      const formatted = `${this.formatDays(days)}: ${this.formatTime(startTime)} – ${this.formatTime(endTime)}`;
      formattedPeriods.push(formatted);
    }
    const formattedClosedDays = this.getClosedPeriodDaysFormatted(periods);
    if (formattedClosedDays !== '') {
      formattedPeriods.push(formattedClosedDays);
    }
    return formattedPeriods.join('\u00A0\u00A0•\u00A0\u00A0');
  }

  /**
   * Provided a FormatDayPeriod[], groups into unique start / end times to combine days into a single array.
   * Example; If Mon, Tue and Wed are all open from 9AM to 5PM they will be grouped into a record
   * {
   *  "09:00:00-17:00:00": ["MON", "TUE", "WED"]
   * }
   */
  groupPeriodsByStartAndEndTime(periods) {
    const periodsGroupedByStartAndEndTime = {};
    for (const period of periods) {
      const startEndKey = `${period.startTime}-${period.endTime}`;
      if (!periodsGroupedByStartAndEndTime[startEndKey]) {
        periodsGroupedByStartAndEndTime[startEndKey] = [];
      }
      periodsGroupedByStartAndEndTime[startEndKey].push(period.dayOfWeek);
    }
    return periodsGroupedByStartAndEndTime;
  }

  /**
   * Formats an unsorted Day[] to a capitalized day string, if consecutive days
   * exist they will be combined to the start and end shortened day.
   *
   * Example: ["FRI", "MON", "TUE", "WED"]
   * Returns: "Mon-Wed, Fri"
   */
  formatDays(days) {
    const sortedDays = days.sort((a, b) => {
      return SORTED_DAYS.indexOf(a) - SORTED_DAYS.indexOf(b);
    });
    let lastDayIndex = -1;
    const formattedDays = [];
    for (const day of sortedDays) {
      const currentIndex = SORTED_DAYS.indexOf(day);
      if (lastDayIndex === -1 || currentIndex !== lastDayIndex + 1) {
        formattedDays.push([day]);
      } else {
        formattedDays[formattedDays.length - 1].push(day);
      }
      lastDayIndex = currentIndex;
    }

    // we use a set date to format the displayed short days in the browser specific language
    const formatter = new Intl.DateTimeFormat(this.userInfo.browserLanguage, {
      weekday: 'short'
    });
    const monday = new Date(2021, 0, 4);
    const internationDaysMap = {};
    for (let i = 0; i < 7; i++) {
      const currentDay = new Date(monday);
      currentDay.setDate(monday.getDate() + i);
      internationDaysMap[i] = formatter.format(currentDay);
    }
    const formattedDaysToShortDays = formattedDays.map(r => r.map(d => internationDaysMap[DAYS_TO_SHORT_MAP[d]]));
    return formattedDaysToShortDays.map(range => {
      if (range.length > 2) {
        return `${range[0]}–${range[range.length - 1]}`;
      }
      if (range.length === 2) {
        return `${range[0]}, ${range[1]}`;
      }
      return range[0];
    }).join(', ');
  }

  /**
   * Converts a 24 hour h:m:s string to a 12 hour formatted string with AM / PM suffixes.
   *
   * Examples:
   * - 00:30:00 -> 12:30AM
   * - 009:00:00 -> 9AM
   * - 17::00 -> 5PM
   */
  formatTime(time) {
    const [hour, minute] = time.split(':').map(Number);

    // We use a set date and hour to format the AM / PM string to the browser specific language
    const formatter = new Intl.DateTimeFormat(this.userInfo.browserLanguage, {
      hour: 'numeric',
      hour12: true
    });
    const amTime = formatter.formatToParts(new Date(2021, 0, 1, 10));
    const pmTime = formatter.formatToParts(new Date(2021, 0, 1, 20));
    const amString = amTime.find(part => part.type === 'dayPeriod')?.value;
    const pmString = pmTime.find(part => part.type === 'dayPeriod')?.value;
    if (hour < 12) {
      return `${hour === 0 ? '12' : hour}${minute === 0 ? '' : `:${minute}`}${amString}`;
    }
    return `${hour === 12 ? '12' : hour - 12}${minute === 0 ? '' : `:${minute}`}${pmString}`;
  }

  /**
   * Looks at all days part of FormatDayPeriod[] to find any days that do not exist. The days are then
   * combined and formatted to a single string if any days are missing. This is appended onto the
   * result of the helper method
   */
  getClosedPeriodDaysFormatted(periods) {
    const closedMap = {
      MON: true,
      TUE: true,
      WED: true,
      THU: true,
      FRI: true,
      SAT: true,
      SUN: true
    };
    for (const p of periods) {
      if (closedMap[p.dayOfWeek]) {
        closedMap[p.dayOfWeek] = false;
      }
    }
    const days = [];
    for (const [key, closed] of Object.entries(closedMap)) {
      if (closed) {
        days.push(key);
      }
    }
    const formattedDays = this.formatDays(days);
    if (formattedDays.length === 0) {
      return '';
    }
    return `${formattedDays}: ${this.intl.t('sharedUi.common.closed')}`;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { FormatDayHourPeriods as default };